// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"3f70b31b","428":"7eae173c","471":"0b3593f7","476":"248b8c10","510":"02aaaa4f","723":"3d3e847a","725":"23914fbc","754":"6e854afb","824":"b66474e7","914":"5b92f06a","980":"030033c9"}[chunkId] + ".chunk.js";
};